import "@github/time-elements";
import SidebarToggler from "./modules/SidebarToggler";
import Time from "./modules/Time";
import Toggler from "./modules/Toggler";
import Tooltip from "./modules/Tooltip";

Time();
Toggler();
Tooltip();
SidebarToggler();
